function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.386.333c-.273 0-.54.105-.75.309L8.15 2.13l3.715 3.726 1.486-1.474c.421-.428.421-1.094 0-1.501L11.13.64a1.069 1.069 0 00-.743-.308zM7.652 2.628L1.974 8.319l1.794.197.127 1.607 1.598.119.203 1.796 5.678-5.69-3.722-3.72zM1.56 8.972L.333 13.666 5.03 12.41l-.168-1.515-1.62-.12-.125-1.628",
  fill: "#9A99A2"
});

function SvgEditSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default SvgEditSmall;